import { Carousel } from "antd";
import { Text } from "melco-ui";
import styled from "styled-components";

// Styled components
const StyledCarousel = styled(Carousel)`
  padding-bottom: 30px;

  .slick-arrow {
    font-size: 24px;
    color: red;
    z-index: 1000; /* Ensure arrows are above slides */
  }

  .slick-prev {
    left: 10px;
  }

  .slick-next {
    right: 10px;
  }

  .custom-dots {
    margin-top: 80px; /* Space between dots and carousel */
  }

  .custom-dots li {
    margin: 0 4px;
  }

  .custom-dots li button {
    border-radius: 50%;
    width: 12px;
    height: 12px;
    background: #999; /* Inactive dot color */
  }

  .custom-dots li.slick-active button {
    background: red; /* Active dot color */
  }
`;

const Slide = styled.div`
  display: flex; /* Use flexbox for horizontal alignment */
  justify-content: center; /* Center the images */
  text-align: center;
  position: relative;

  img {
    width: 100%;
    height: auto; /* Maintain aspect ratio */
    max-height: 350px; /* Limit height for uniformity */
    object-fit: contain; /* Ensure the entire image is visible */
    margin: 0 auto; /* Center the image horizontally */
  }
`;

const TextWrapper = styled.div`
  margin: 10px;
`;

// Props interface for ImageCarousel
interface ImageCarouselProps {
  items: { imgSrc: string; text: string }[];
  slidesToShow?: number;
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({
  items,
  slidesToShow = 1,
}) => {
  return (
    <StyledCarousel
      slidesToShow={slidesToShow}
      dots={{ className: "custom-dots" }}
      arrows
    >
      {items.map((item, index) => (
        <Slide key={index}>
          <img src={item.imgSrc} alt={`Image${index + 1}`} />
          <TextWrapper>
            <Text>{item.text}</Text>
          </TextWrapper>
        </Slide>
      ))}
    </StyledCarousel>
  );
};

export default ImageCarousel;
